module.exports = __webpack_public_path__ + "img/undraw_product_tour_foyt.6dccfb11.svg";